import React from 'react';
import LanguageSelector from '../LanguageSelector';

interface HeaderProps {
  apiHealthy: boolean;
  getCurrentStep: () => string | undefined;
  onClearConversation: () => void;
  onShowFeedback: () => void;
  t: any;
}

const Header: React.FC<HeaderProps> = ({
  apiHealthy,
  getCurrentStep,
  onClearConversation,
  onShowFeedback,
  t
}) => {
  return (
    <header className="bg-gradient-to-r from-emerald-600 to-emerald-700 text-white shadow-lg flex-shrink-0">
      <div className="w-full px-3 md:px-4 py-1 md:py-1.5 sm:py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 md:space-x-3 min-w-0 flex-1">
            <div className="w-6 h-6 md:w-8 md:h-8 sm:w-10 sm:h-10 bg-white/20 rounded-lg md:rounded-xl flex items-center justify-center backdrop-blur-sm flex-shrink-0">
              <span className="text-sm md:text-lg sm:text-xl">🏔️</span>
            </div>
            <div className="min-w-0 flex-1">
              <h1 className="text-sm md:text-base sm:text-lg font-bold truncate">{t('header.title')}</h1>
              <p className="text-emerald-100 text-xs hidden md:block">{t('header.subtitle')}</p>
            </div>
          </div>
          <div className="flex items-center space-x-1.5 md:space-x-2 sm:space-x-3 flex-shrink-0">
            <div className={`flex items-center space-x-1 px-1.5 md:px-2 py-0.5 md:py-1 rounded-full text-xs ${
              apiHealthy ? 'bg-green-500/20 text-green-100' : 'bg-red-500/20 text-red-100'
            }`}>
              <div className={`w-1.5 h-1.5 md:w-2 md:h-2 rounded-full ${apiHealthy ? 'bg-green-400' : 'bg-red-400'}`}></div>
              <span className="hidden md:inline">{apiHealthy ? t('header.online') : t('header.offline')}</span>
            </div>
            <LanguageSelector />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;